import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { intentCopy } from '../data/plans';

// Shown when a public CTA landed on /orgs?plan=team|kit so the two products
// do not collapse into one subscribe button.
export default function CheckoutIntent() {
  const [params] = useSearchParams();
  const copy = intentCopy(params.get('plan'));
  if (!copy) return null;
  return (
    <div id="checkout-intent" className="cs-card" style={{ padding: 14, marginTop: 16 }}>
      <strong style={{ color: 'var(--text)' }}>{copy.title}</strong>
      <p className="cs-help" style={{ margin: '6px 0 0' }}>{copy.body}</p>
    </div>
  );
}
